export type MediaRef = {
  assetId?: string;
  url?: string;
  alt?: string;
  width?: number;
  height?: number;
};

export function hasExactlyOneRef(ref: MediaRef): boolean {
  const count = (ref.assetId ? 1 : 0) + (ref.url ? 1 : 0);
  return count === 1;
}
